import { borders as e, borderRadii as p, borderWidths as a } from "./borders.js";
import { colors as s } from "./colors.js";
import { themeVars as t } from "./theme.js";
const o = {
  mobile: "0px",
  tablet: "740px",
  desktop: "992px",
  wide: "1200px"
}, d = Object.keys(o), r = {
  0: "0",
  1: "1px",
  3: "3px",
  2: "2px",
  4: "4px",
  6: "6px",
  7: "7px",
  8: "8px",
  9: "9px",
  10: "10px",
  12: "12px",
  16: "16px",
  20: "20px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px",
  40: "40px",
  44: "44px",
  48: "48px"
}, b = {
  breakpoint: o,
  color: s,
  space: r,
  theme: t,
  margin: {
    auto: "auto",
    ...r
  },
  padding: {
    auto: "auto",
    inherit: "inherit",
    ...r
  },
  border: e,
  borderRadius: p,
  borderWidth: a,
  borderStyle: {
    standard: "solid"
  },
  transforms: {
    touchable: "scale(0.97)"
  },
  transitions: {
    fast: "transform .125s ease, opacity .125s ease",
    touchable: "transform 0.2s cubic-bezier(0.02, 1.505, 0.745, 1.235)"
  },
  shadows: {
    small: "0 2px 8px -2px rgba(59, 59, 59, 0.08)",
    medium: "0 6px 12px -2px rgba(59, 59, 59, 0.12)",
    innerPrimary: "0 -1px 0 0 rgba(0, 0, 0, 0.32) inset",
    innerSecondary: "0 -1px 0 0 rgba(0, 0, 0, 0.1) inset"
  },
  overflow: ["auto", "hidden", "visible", "scroll"],
  zIndex: {
    tooltip: 10
  }
};
export {
  d as b,
  b as v
};
//# sourceMappingURL=vars-BxiGwZcN.js.map
